var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 133,
    viewBox: "0 0 134 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bytesize:upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.9057 91.4373C0.499443 95.5935 4.65569 49.8748 37.9057 54.031C25.4369 8.3123 96.0932 8.3123 91.9369 41.5623C133.499 29.0935 133.499 95.5935 96.0932 91.4373M46.2182 74.8123L66.9994 58.1873M66.9994 58.1873L87.7807 74.8123M66.9994 58.1873V120.531",
    stroke: "#1744E2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.88278d795e8443a308f0ae665ff1bfbf.svg";
export { ForwardRef as ReactComponent };